import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const UserMissionsStateActionTypes = Object.freeze({
  UPDATE_STATE: 'USER_MISSIONS:UPDATE_STATE',
  UPDATE_REGISTERED_MISSIONS: 'USER_MISSIONS:UPDATE_REGISTERED_MISSIONS',
  REQUEST_REFRESH_USER_MISSIONS_STATE: 'USER_MISSIONS:REQUEST_REFRESH_STATE',
  REFRESH_USER_MISSIONS_STATE: 'USER_MISSIONS:REFRESH_STATE',
});

export type UserMissionsStateActionType = ObjectValuesUnionType<typeof UserMissionsStateActionTypes>;
